import React, { useState } from 'react';
import { Grid, Box, Button, InputLabel, OutlinedInput } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { gridSpacing } from 'utils/constants';
import ApiHelper from 'utils/apiHelper';
import MainCard from 'components/Cards/MainCard';
import SubCard from 'components/Cards/SubCard';
import ChangePasswordDialog from './ChangePasswordDialog';
import { getUserDetails } from 'components/../redux/actions/auth';
import { validateEmail } from 'utils/commonHelpers';

const AccountSettings = () => {
    const dispatch = useDispatch();
    const { userInfo } = useSelector((state) => state.auth);
    const initialState = {
        firstName: userInfo.user.first_name,
        lastName: userInfo.user.last_name,
        username: userInfo.user.username,
        email: userInfo.user.email
    };
    const [{ firstName, lastName, username, email }, setState] = useState(initialState);
    const [showChangePasswordDialog, setShowChangePasswordDialog] = useState(false);

    const clearState = () => {
        setState({ ...initialState });
    };

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        if (name == 'username' && value.length > userInfo.input_fields.name) {
            toast.warning('This field must be ' + userInfo.input_fields.name + ' characters or less.');
            return;
        }
        if (name == 'email' && value.length > userInfo.input_fields.email) {
            toast.warning('This field must be ' + userInfo.input_fields.email + ' characters or less.');
            return;
        }
        if (name == 'firstName' && value.length > userInfo.input_fields.f_name) {
            toast.warning('This field must be ' + userInfo.input_fields.f_name + ' characters or less.');
            return;
        }
        if (name == 'lastName' && value.length > userInfo.input_fields.l_name) {
            toast.warning('This field must be ' + userInfo.input_fields.l_name + ' characters or less.');
            return;
        }
        setState((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleSubmit = () => {
        if (username === '') {
            toast.error('Username should be required');
            return true;
        }
        if (email === '') {
            toast.error('Email is required');
            return true;
        }
        if (!validateEmail(email)) {
            toast.error('Invalid email format');
            return true;
        }
        ApiHelper.post('/api/auth/account_settings/', {
            first_name: firstName,
            last_name: lastName,
            username: username,
            email: email
        })
            .then(() => {
                toast.success('Successfully updated.');
                dispatch(getUserDetails());
            })
            .catch((err) => {
                if (err.response.data.message !== '') {
                    toast.error(`Failed! ${err.response.data.message}`);
                } else {
                    toast.error('Failed to update');
                }
            });
    };

    return (
        <MainCard title="Account Settings" cardHeaderTitle="Account Settings" cardHeaderShow={true}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={4}>
                    <SubCard title="User Account Settings">
                        <Grid container>
                            <Grid item xs={12} sx={{ padding: '0 5px' }}>
                                <InputLabel>First Name </InputLabel>
                                <OutlinedInput sx={{ width: '100%' }} value={firstName} name="firstName" onChange={handleChangeInput} />
                            </Grid>
                            <Grid item xs={12} sx={{ padding: '0 5px', mt: 2 }}>
                                <InputLabel>Last Name </InputLabel>
                                <OutlinedInput sx={{ width: '100%' }} value={lastName} name="lastName" onChange={handleChangeInput} />
                            </Grid>
                            <Grid item xs={12} sx={{ padding: '0 5px', mt: 2 }}>
                                <InputLabel>Username </InputLabel>
                                <OutlinedInput sx={{ width: '100%' }} value={username} name="username" onChange={handleChangeInput} />
                            </Grid>
                            <Grid item xs={12} sx={{ padding: '0 5px', mt: 2 }}>
                                <InputLabel>Email </InputLabel>
                                <OutlinedInput sx={{ width: '100%' }} value={email} name="email" disabled />
                            </Grid>
                            <Grid item xs={12} sx={{ padding: '0 5px', mt: 2 }}>
                                <Box sx={{ float: 'right' }}>
                                    <Button
                                        sx={{ marginRight: 2 }}
                                        color="secondary"
                                        variant="contained"
                                        onClick={() => setShowChangePasswordDialog(true)}
                                    >
                                        Change Password
                                    </Button>
                                    <Button variant="contained" color="info" sx={{ marginRight: 2 }} onClick={clearState}>
                                        Cancel
                                    </Button>
                                    <Button variant="contained" onClick={handleSubmit}>
                                        Save
                                    </Button>
                                </Box>
                            </Grid>
                            {showChangePasswordDialog && <ChangePasswordDialog onClose={() => setShowChangePasswordDialog(false)} />}
                        </Grid>
                    </SubCard>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default AccountSettings;
